<template>
    <v-layout row>
        <v-flex pa-2 xs12 sm6 offset-sm3>
            <v-card flat>
                <v-card-title class="indigo">
                    <span class="white--text">PROBLEMAS</span>
                </v-card-title>
                <v-list two-line>

                    <template v-for="item in problemas">
                        <v-list-tile
                            ripple
                            :key="'item' +item.id_problema_os"
                        >

                            <v-list-tile-content>
                                <v-list-tile-sub-title class="text--primary">{{ item.problema }}</v-list-tile-sub-title>
                            </v-list-tile-content>

                        </v-list-tile>
                        <v-divider :key="'divider' + item.id_problema_os"/>
                    </template>

                </v-list>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {
        name: "list-problemas",
        props: {
            problemas: {
                default: []
            }
        }
    };
</script>

<style scoped>

</style>
